import { renderEmailAdresses, segmentEmailAdresses } from "./_link.script";

renderEmailAdresses();
segmentEmailAdresses();
